import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonLabel
} from '@ionic/react';

import styles from './ErrorCard.module.scss';

import { State } from '../../constants/state';
import { Service } from '../../services/service';
import { formatErrorMessage } from '../../util/format';
import { GitLiveLogo } from '../GitLiveLogo/GitLiveLogo';
import { LinkifyText } from '../LinkifyText/LinkifyText';
import { ServiceLoader } from '../ServiceLoader/ServiceLoader';

export interface ErrorCardProps {
  getSignInLink?: (token?: boolean) => string;
  message: string;
  service?: Service;
  title: string;
  userToken?: boolean;
}

export const ErrorCard = ({
  title,
  message,
  service,
  userToken,
  getSignInLink
}: ErrorCardProps) => (
  <div className={styles.cardContainer}>
    {service ? (
      <ServiceLoader service={service.id} state={State.Error} />
    ) : (
      <GitLiveLogo />
    )}
    <IonCard className={styles.card}>
      <IonCardHeader>
        <IonCardTitle className={styles.title}>{title}</IonCardTitle>
      </IonCardHeader>

      <IonCardContent>
        <LinkifyText text={formatErrorMessage(message)} />
      </IonCardContent>

      {getSignInLink && (
        <footer className={styles.footer}>
          <IonButton
            color="primary"
            fill="solid"
            expand="block"
            href={getSignInLink(!userToken)}
          >
            {!service?.isCloud
              ? 'Retry Sign In'
              : `Sign in with ${userToken ? 'OAuth' : service.patName.toLowerCase()} instead`}
          </IonButton>
          <hr />
          {service?.isCloud && (
            <IonLabel>
              <a className={styles.btn} href={getSignInLink(userToken)}>
                {userToken
                  ? `Or try again with ${service.patName.toLowerCase()}`
                  : 'Or try again with OAuth'}
              </a>
            </IonLabel>
          )}
        </footer>
      )}
    </IonCard>
  </div>
);
